import ProductionsListingPage from "./views/productions/ProductionsListing.vue";
import ProductionDetails from "./views/productions/ProductionDetails.vue"
import InvoicesListing from "./views/invoices/InvoicesListing.vue";
import ReturnsListing from "./views/returns/ReturnsListing.vue";
import CatalogDashboard from "./views/home/CatalogDashboard.vue";
import OrderListDisplayWrapper from "./views/orders/OrderListDisplayWrapper.vue";
import Stock from "./views/stock/Stock.vue";
import AccountsListing from "./views/accounts/AccountsListing.vue";
import OffersListing from "./views/offers/OffersListing.vue";
import ContractsListing from "./views/contracts/ContractsListing.vue";
import AssetsListing from "./views/assets/AssetsListing.vue";
import ProductListingPage from "./views/product/ProductListingPage.vue";
import TransactionsListing from "./views/contracts/TransactionsListing.vue";
import InvoicesGenerator from "./views/contracts/InvoiceGenerator.vue"
import CardListing from "./views/cards/CardsListing.vue";
import CardDesignConstructor from "@pazion/pazion-catalog/src/views/cards/parts/CardDesignConstructor.vue";
import CardMembersListing from "./views/cards/CardMembersListing.vue";
import MembershipCard from "./views/cards/MembershipCard.vue";
import FulfilmentListing from "./views/fulfilment/FulfilmentListing.vue"
import FulfilmentPickerListing from "@pazion/pazion-catalog/src/views/fulfilment/FulfilmentPickerListing.vue";


export function getCatalogRoutes() {

    return [
        {
            path: '/dashboard',
            name: 'dashboard',
            component: CatalogDashboard,
            meta: {
                'show-in-nav': false,
                roles: ['user'],
                sort: -100,
            }
        },
        {
            path: '/offers',
            name: 'offers',
            component: OffersListing,
            meta: {
                'show-in-nav': true,
                profilePermission: 'offerManagement.show',
                roles: ['user'],
                sort: -95
            },
        },
        {
            path: '/products',
            name: 'products',
            component: ProductListingPage,
            meta: {
                'show-in-nav': true,
                profilePermission: 'productManagement.show',
                roles: ['user'],
                sort: -90
            },
        },
        {
            path: '/accounts',
            name: 'accounts',
            component: AccountsListing,
            meta: {
                'show-in-nav': true,
                profilePermission: 'accountManagement.show',
                roles: ['user'],
                sort: -80
            },
        },
        {
            path: '/orders',
            name: 'orders',
            component: OrderListDisplayWrapper,
            meta: {
                'show-in-nav': true,
                profilePermission: 'orderManagement.show',
                roles: ['user'],
                sort: -70
            },
        },
        {
            path: '/productions',
            name: 'productions',
            component: ProductionsListingPage,
            meta: {
                'show-in-nav': true,
                profilePermission: 'productionManagement.show',
                roles: ['user', 'production'],
                sort: -64
            },
        },
        {
            path: '/picking',
            name: 'picking',
            component: FulfilmentPickerListing,
            meta: {
                'show-in-nav': true,
                profilePermission: 'fulfilmentPickManagement.show',
                roles: ['user'],
                sort: -60
            }
        },
        {
            path: '/shipments',
            name: 'shipments',
            component: FulfilmentListing,
            meta: {
                'show-in-nav': true,
                profilePermission: 'fulfilmentManagement.show',
                roles: ['user'],
                sort: -60
            }
        },
        {
            path: '/invoices',
            name: 'invoices',
            component: InvoicesListing,
            meta: {
                'show-in-nav': true,
                'profilePermission': 'invoiceManagement.show',
                roles: ['user'],
                sort: -50
            },
        },
        {
            path: '/returns',
            name: 'returns',
            component: ReturnsListing,
            meta: {
                'show-in-nav': true,
                profilePermission: 'returnManagement.show',
                roles: ['user'],
                sort: -40
            },
        },
        {
            path: '/stock',
            name: 'stock',
            component: Stock,
            meta: {
                'show-in-nav': true,
                profilePermission: 'stockManagement.show',
                roles: ['user'],
                sort: -30
            }
        },
        {
            path: '/contracts',
            name: 'contracts',
            component: ContractsListing,
            meta: {
                'show-in-nav': true,
                profilePermission: 'contractManagement.show',
                roles: ['user'],
                sort: -65
            },
        },
        {
            path: '/assets',
            name: 'assets',
            component: AssetsListing,
            meta: {
                'show-in-nav': true,
                //TODO: add assetMansgment.show
                profilePermission: 'contractManagement.show',
                roles: ['user'],
                sort: -60
            },
        },
        {
            path: '/transactions',
            name: 'transactions',
            component: TransactionsListing,
            meta: {
                'show-in-nav': false,
                profilePermission: 'transactionManagement.show',
                roles: ['user'],
                sort: -60
            },
        },
        {
            path: '/invoices-generator',
            name: 'invoicesGenerator',
            component: InvoicesGenerator,
            meta: {
                'show-in-nav': false,
                profilePermission: 'invoiceManagement.show',
                roles: ['user'],
                sort: -55
            },
        },
        {
            path: '/productions/details/:sku',
            name: 'production_details',
            component: ProductionDetails,
            props: true,
            meta: {
                'show-in-nav': false,
                details: true
            }
        },
        {
            path: '/cards',
            name: 'cards',
            component: CardListing,
            meta: {
                'show-in-nav': true,
                profilePermission: 'membersCardManagement.show',
                roles: ['user'],
                sort: -55
            },
        },
        {
            path: '/card-members',
            name: 'card-members',
            component: CardMembersListing,
            meta: {
                'show-in-nav': true,
                profilePermission: 'membersCardManagement.show',
                roles: ['user'],
                sort: -55
            },
        },
        {
            path: '/card-design/:cardId',
            name: 'card-design',
            component: CardDesignConstructor,
            props: true,
            meta: {
                'show-in-nav': false,
                profilePermission: 'membersCardManagement.show',
                roles: ['user'],
                sort: -55
            },
        },
        {
            path: '/member-login',
            name: 'membership-pass',
            alias: '/member',
            component: MembershipCard,
            meta: {
                'show-in-nav': false,
                profilePermission: 'membersCardManagement.show',
                guest: true,
                roles: ['user'],
                hideHeader: true
            }
        }
    ];
}


